const STORAGE_KEY = "gf04_reality_check_latencies";
const MAX_RECORDS = 200;

function readStore() {
  if (typeof localStorage === "undefined") return [];

  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return [];

    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

function writeStore(records) {
  if (typeof localStorage === "undefined") return;

  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(records));
  } catch {
    // Ignore storage failures (quota/private mode) so experiment flow is not blocked.
  }
}

export function saveRealityCheckLatency(record) {
  const records = readStore();
  records.push(record);

  if (records.length > MAX_RECORDS) {
    records.splice(0, records.length - MAX_RECORDS);
  }

  writeStore(records);
}

export function getRealityCheckLatencies() {
  return readStore();
}
